export default "__VITE_ASSET__3b85835c__"